import updateValueInLocalStorage from "./updateValueInLocalStorage";

export default function(key) {
  try {
    return localStorage[key] || "";
  } catch (error) {
    updateValueInLocalStorage(key, "");
    return "";
  }
}
